// You can write more code here

/* START OF COMPILED CODE */

import EntitySmashable from "../../EntitySmashable";
/* START-USER-IMPORTS */
import { CharacterSkinsValues } from '../../../CharacterSpine';
/* END-USER-IMPORTS */

export default class EntitySmashableRocks extends EntitySmashable {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 76, y ?? 187);

    // rocks
    const rocks = scene.add.image(0, 0, 'game-all', "smashable-rocks.png");
    this.add(rocks);

    // icon
    const icon = scene.add.image(0, 10, "game", "icon-grizz.png");
    icon.scaleX = 1.25;
    icon.scaleY = 1.25;
    this.add(icon);

    // icon1
    const icon1 = scene.add.image(0, -91, "game", "icon-grizz.png");
    icon1.scaleX = 1.25;
    icon1.scaleY = 1.25;
    this.add(icon1);

    // icon2
    const icon2 = scene.add.image(0, 111, "game", "icon-grizz.png");
    icon2.scaleX = 1.25;
    icon2.scaleY = 1.25;
    this.add(icon2);

    this.rocks = rocks;
    this.icon = icon;
    this.icon1 = icon1;
    this.icon2 = icon2;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private rocks: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;
  private icon1: Phaser.GameObjects.Image;
  private icon2: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public reset(allowedCharacter?: CharacterSkinsValues) {
    super.reset(allowedCharacter);
    let iconCharacter = allowedCharacter ? allowedCharacter : this.allowedCharacter;

    this.icon.setFrame(EntitySmashableRocks.iconLookup.get(iconCharacter) ?? EntitySmashableRocks.defaultIcon);
    this.icon1.setFrame(EntitySmashableRocks.iconLookup.get(iconCharacter) ?? EntitySmashableRocks.defaultIcon);
    this.icon2.setFrame(EntitySmashableRocks.iconLookup.get(iconCharacter) ?? EntitySmashableRocks.defaultIcon);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.rocks.displayWidth, this.rocks.displayHeight);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
